module.exports = __webpack_public_path__ + "img/dark.c29821e9.png";